<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{nzModalData.nzTitle}}</p>
    </div>
</div>

<div #modalContent class="w-full h-full p-3 m-0">
    @if (isLoading) {
        <app-loader></app-loader>
    } @else {
        @if (orderProcess.rawMaterialsUsed.length > 0) {
                <div class="items-center mb-5 max-height">
                    <nz-table #basicTable [nzData]="orderProcess.rawMaterialsUsed" class="m-0 p-0 max-height" nzSize="small" [nzLoading]="isLoading"
                        nzTableLayout="auto" [nzBordered]="true" [nzFrontPagination]="false" [nzShowPagination]="false"
                        [nzScroll]="{ y: (tableHeight || 0) + 'px' }">
                        <thead>
                            <tr>
                                <th id="article">Artículo <span class="font-semibold">(Materias compatibles)</span></th>
                                <th nzWidth="100px" id="batch">Lote</th>
                                <th nzWidth="100px" id="quantity">Formato</th>
                                <th nzWidth="100px" id="quantity">Cantidad consumida</th>
                                <th nzWidth="100px" id="packaging">Operario</th>
                                <th nzWidth="100px" id="packaging">Acci&oacute;n</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (rawMaterial of basicTable.data; track rawMaterial; let idx = $index) {
                            <tr>
                                <td>
                                    {{ rawMaterial.article?.name }}
                                </td>
                                <td>
                                    {{ rawMaterial.articleBatch ? rawMaterial.articleBatch.batchNumber : '-' }}
                                </td>
                                <td>
                                    {{ rawMaterial.usedPackaging ? rawMaterial.usedPackaging.batchNumber : '-' }}
                                </td>
                                <td>
                                    {{ rawMaterial.rawQuantity }} {{ rawMaterial.article?.measurementUnit?.abbreviation }}
                                </td>
                                <td>
                                    {{ rawMaterial.createdBy ? rawMaterial?.createdBy?.name : '-' }}
                                </td>
                                @if(this.canDelete && this.isFromOrderProcessDetail){
                                    <td>
                                        <div class="flex justify-center">
                                            <button
                                                (click)="editRawMaterial(rawMaterial)"
                                                nz-button nzType="text" nzShape="circle" class="table-icon"
                                                [nzTooltipTitle]="'Editar materia prima'" nzTooltipPlacement="bottom" nz-tooltip
                                                [disabled]="isDisabled(rawMaterial.createdById)"
                                            >
                                                <span nz-icon nzType="edit"></span>
                                            </button>
                                        </div>
                                    </td>
                                }
                            </tr>
                            }
                        </tbody>
                    </nz-table>
                </div>
        } @else {
            <div class="w-full h-full content-center">
                <nz-empty></nz-empty>
            </div>
        }
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button mr-2">
            Cancelar
        </button>
    </div>
</div>
